export const roundToDecimal = (value, decimals = 2) => {
    if (value === "**" || String(value).trim() === "**") {
        return "**";
    }
    if (value === null || value === undefined || value === "") {
        return "0.00";
    }
    const num = parseFloat(value);
    if (isNaN(num)) {
        return "0.00";
    }
    return num.toFixed(decimals);
};
